<div id="residency" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty?.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty?.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Residency History</h2>
            <p *ngIf="AddAdditionalApplicantKey == null">Please provide at least two years of residency history</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">Please provide at least
              two years of residency history for the additional applicant.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">Please provide at least
              two years of residency history for {{AddAdditionalApplicantName}}.</p>
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
      <form name="rentalForm" id="rentalForm" #rentalForm="ngForm" class="flex flex-col pt-8">
        <div *ngFor="let hist of history; let i = index; let p = index; trackBy:ListTrack; first as isFirst">
          <div>
            <label for="EmployerName" *ngIf="isFirst">Current Address</label>
            <label for="EmployerName" *ngIf="!isFirst">Previous Address</label>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Address</mat-label>
                <input matInput name="Address[{{i}}]" id="Address[{{i}}]" required [(ngModel)]="hist.Address"
                  #Address="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>City</mat-label>
                <input matInput name="City[{{i}}]" id="City[{{i}}]" required [(ngModel)]="hist.City" #City="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>State</mat-label>
                  <mat-select name="State[{{i}}]" id="State[{{i}}]" required [(ngModel)]="hist.State" #State="ngModel">
                    <mat-option *ngFor="let state of states" [value]="state.value">
                      {{state.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Zip</mat-label>
                  <input matInput name="Zip[{{i}}]" id="Zip[{{i}}]" required [(ngModel)]="hist.Zip" #Zip="ngModel">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="ii" id="startDate[{{i}}]" required
                    [(ngModel)]="hist.StartDate" name="startDate[{{i}}]" #StartDate="ngModel" [min]="minDate">
                  <mat-datepicker-toggle matSuffix [for]="ii"></mat-datepicker-toggle>
                  <mat-datepicker #ii [(ngModel)]="hist.StartDate" [ngModelOptions]="{standalone: true}"></mat-datepicker>
                  <mat-error *ngIf="StartDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                  <mat-error *ngIf="StartDate.hasError('matDatepickerParse')">
                    "{{StartDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="iii" name="endDate[{{i}}]" id="endDate[{{i}}]"
                    [(ngModel)]="hist.EndDate" #EndDate="ngModel" [min]="minDate">
                  <mat-datepicker-toggle matSuffix [for]="iii"></mat-datepicker-toggle>
                  <mat-datepicker #iii [(ngModel)]="hist.EndDate" [ngModelOptions]="{standalone: true}"></mat-datepicker>
                  <mat-error *ngIf="EndDate.hasError('matDatepickerMin')">Year is invalid</mat-error>
                  <mat-error *ngIf="EndDate.hasError('matDatepickerParse')">
                    "{{EndDate.getError('matDatepickerParse').text}}" is not valid, Please fill out this field MM/DD/YYYY
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="md:flex">
              <div class="md:w-1/2 md:pr-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Reason For Move</mat-label>
                  <mat-select name="Reason[{{i}}]" id="Reason[{{i}}]" required [(ngModel)]="hist.RentalMoveInReasonKey"
                    #State="ngModel">
                    <mat-option *ngFor="let reason of moveReasons" [value]="reason.value">
                      {{reason.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Rent</mat-label>
                  <input matInput name="RentAmount[{{i}}]" id="RentAmount[{{i}}]" required [(ngModel)]="hist.RentAmount"
                    #RentAmount="ngModel" numberCeilingRounder>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div>
            <button mat-button color="accent" [ngStyle]="{'display': (history.length > 1) ? 'inline-block': 'none'}"
              (click)="onRemoveHistoryClick(hist)" style="color: #545859">Remove Residency</button>
          </div>
        </div>
        <div class="md:flex md:justify-between md:items-center ">
          <div>
            <button mat-button color="accent" (click)="onAddHistoryClick()" style="color: #545859">ADD ADDITIONAL
              RESIDENCY HISTORY</button>
          </div>
          <div class="text-right">
            <button mat-flat-button color="primary" (click)="cancelEdit()" class="h-10 px-6 my-2"
              *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>
            <button mat-flat-button color="primary" (click)="checkRentalHistory()" class="h-10 px-6 my-2 ml-2"
              [disabled]="!rentalForm.form.valid || disableSubmitBtn">CONTINUE</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
